<template>
  <v-card id="drugs-list" class="mb-2">
    <v-card-title class=" align-center">
      <v-btn elevation="1" class="mr-3" fab small @click="TOGGLE_CLOSED_BLOCK('drugs')" color="white">
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
      <h2>Лекарства пациента</h2>
      <div class="ml-auto">
        <modal depressed icon="add" title="Добавить лекарство" name="Лекарство" component="add-medicine"></modal>
      </div>
    </v-card-title>
    <drugs-list v-if="isShow" :class="{ 'mt-2': hidePatient }" />
  </v-card>
</template>

<script>
import Modal from "@/components/Modal";
import DrugsList from "@/views/pages/drugs/components/DrugsList";
import { mapMutations, mapState } from "vuex";
import PatientHeader from "@/components/PatientHeader";
export default {
  name: "Drugs",
  props: {
    hidePatient: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DrugsList,
    Modal,
    PatientHeader,
  },
  computed: {
    ...mapState("ikp", ["closedBlocks"]),
    isShow() {
      return !this.closedBlocks.includes("drugs");
    },
  },
  methods: {
    ...mapMutations("ikp", ["TOGGLE_CLOSED_BLOCK"]),
  },
};
</script>

<style scoped></style>
